import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(customParseFormat);

export const getNextReport = (reports, platformTime, hideWithoutLinks = true, isBbbCanBeUsedInSeparateLessons, isRemoveLinksToOfflineClasses) => {

    let nextReport = null;
    let minTimeDiff = Infinity;
    
    reports.forEach(report => {
        const conferenceDateTime = dayjs(`${report.date_conference} ${report.start_time}`, 'YYYY-MM-DD HH:mm');
        if (conferenceDateTime.isAfter(dayjs(platformTime))) {
            const timeDiff = conferenceDateTime.diff(dayjs(platformTime));
            
            if (timeDiff < minTimeDiff) {
                minTimeDiff = timeDiff;
                nextReport = report;
            }
        }
    });
      
    return nextReport;
}
